import React, { FC, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import {
  Block,
  FormRow,
  Form,
} from 'ia-react-core';
import { useDispatch } from 'react-redux';
import cookie from 'cookie';
import ChangePasswordContext from '../../../utils/ChangePasswordContext';
import { StyledInfo, StyledDiv, StyledPwdInfoStyledFormCol, StyledTitle, StyledConfirmButtonActionBarWrapper, WidgetGlobalStyles } from './ChangePasswordForm.styles';

import ConfirmButtonActionBar from './ConfirmButtonActionBar';
import ErrorModal from './ErrorModal';
import { setIsModalOpened } from '../ChangePasswordPage.actions';
import ErrorMessageBox from './ErrorMessageBox';
import ChangePasswordSection from '../../../components/ChangePasswordSection';
export interface ChangePasswordProps {
  mobileDeviceMode: Boolean;
}

const ChangePasswordForm: FC<ChangePasswordProps> = ({ mobileDeviceMode }) => {
  const dispatch = useDispatch();
  const { t } = useTranslation('ChangePasswordPage');
  const { sitecoreDictionary } = useContext(ChangePasswordContext);
  const cookies = cookie.parse(document.cookie);
  const { oktaStateToken } = cookies;
  const title = t('Title');

  if (oktaStateToken === undefined) {
    // TODO : Extranet team to detail the reason behind that cookie requirement ??
    console.log('No available information; Will be unable to change password.');
    dispatch(setIsModalOpened(true));
  }
  return (
    <div>
      <WidgetGlobalStyles />
      <ErrorModal />
      {sitecoreDictionary ? (
        <StyledDiv>
          {!mobileDeviceMode ? <StyledTitle>{title}</StyledTitle> : null}
          <ErrorMessageBox />
          <Block white>
            <Form name="ChangePasswordForm" onSubmit={onsubmit}>
              <FormRow defaultCol={12}>
                <StyledPwdInfoStyledFormCol>
                  <StyledInfo>{t('PasswordInfoMsg')}</StyledInfo>
                </StyledPwdInfoStyledFormCol>
              </FormRow>
              <ChangePasswordSection />
              <StyledConfirmButtonActionBarWrapper>
                <ConfirmButtonActionBar />
              </StyledConfirmButtonActionBarWrapper>
            </Form>
          </Block>
        </StyledDiv>) : null}
    </div>
  );
};

export default ChangePasswordForm;
